import * as React from 'react'
import MUITableRow from '@mui/material/TableRow'

const TableRow = (props) => <MUITableRow {...props} />

export default TableRow
